import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './whole';

export default function () {
  return <SalesIndex ctaOverride="sales99" ctaNoTimer />;
}
